{
  "version": 1,
  "asset_id": "4da123ba-f728-4c51-af43-7e4c504eb798",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4da123ba-f728-4c51-af43-7e4c504eb798/loc-fort-worth-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4da123ba-f728-4c51-af43-7e4c504eb798/loc-fort-worth-1280.avif",
  "original_filename": "loc-fort-worth-1280.avif",
  "size": 64726,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:24Z"
}
